import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'itl-desktop-detail-view-header',
  templateUrl: './desktop-detail-view-header.component.html',
  styleUrls: ['./desktop-detail-view-header.component.scss'],
  standalone: false,
})
export class DesktopDetailViewHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
